export default "__VITE_ASSET__h98Kz93T__"